/* RUB HUB — RubHub Emoticons sitewide helper (2026-10-26)
   Footer contact list: makes the phone number a tap-to-call link and the email a
   mailto link, and moves the postal address into the same emoticon list (map pin).
   Safe to remove: the CSS still shows the emoticons without this script. */
(function () {
  function run() {
    var blocks = document.querySelectorAll('.footer-block__newsletter .rte');
    blocks.forEach(function (rte) {
      var list = rte.querySelector('.content-wrapper');
      if (!list || list.getAttribute('data-rh-emo') === '1') return;
      list.setAttribute('data-rh-emo', '1');

      var phone = list.querySelector('.phone-wrapper p');
      if (phone && !phone.querySelector('a')) {
        var num = phone.textContent.trim();
        var a = document.createElement('a');
        a.href = 'tel:' + num.replace(/[^\d+]/g, '').replace(/^0/, '+61');
        a.textContent = num;
        a.setAttribute('aria-label', 'Call or text The Rub Hub on ' + num);
        phone.textContent = '';
        phone.appendChild(a);
      }

      var mail = list.querySelector('.email-wrapper p');
      if (mail && !mail.querySelector('a')) {
        var addr = mail.textContent.trim();
        var m = document.createElement('a');
        m.href = 'mailto:' + addr;
        m.textContent = addr;
        m.setAttribute('aria-label', 'Email The Rub Hub at ' + addr);
        mail.textContent = '';
        mail.appendChild(m);
      }

      var post = rte.querySelector(':scope > p');
      if (post && post.textContent.trim() && !list.querySelector('.rh-address-wrapper')) {
        var row = document.createElement('div');
        row.className = 'rh-address-wrapper content-piece';
        var ic = document.createElement('span');
        ic.className = 'icon';
        ic.setAttribute('aria-hidden', 'true');
        var txt = document.createElement('div');
        var p = document.createElement('p');
        /* one line: "PO Box 2064, Armstrong Creek VIC 3217, Australia" */
        p.textContent = post.innerHTML.split(/<br\s*\/?>/i).map(function (x) {
          var d = document.createElement('div'); d.innerHTML = x; return d.textContent.trim();
        }).filter(Boolean).join(', ');
        txt.appendChild(p);
        row.appendChild(ic);
        row.appendChild(txt);
        list.appendChild(row);
        post.classList.add('rh-address-moved');
      }
    });
  }
  /* footer social row: add the Rub Smuggler (links to his Chart Room bio) after TikTok */
  function addSmuggler() {
    document.querySelectorAll('.footer-block__list-social .list-social').forEach(function (ul) {
      if (ul.querySelector('.icon-smuggler')) return;
      var li = document.createElement('li');
      li.className = 'list-social__item';
      var a = document.createElement('a');
      a.href = '/pages/chart-room';
      a.className = 'link link--text list-social__link icon-smuggler';
      a.setAttribute('aria-label', 'Meet the Rub Smuggler');
      a.title = 'Meet the Rub Smuggler';
      li.appendChild(a);
      ul.appendChild(li);
    });
  }
  function boot() { run(); addSmuggler(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* Desktop header social row (2026-10-26): clone the footer social links into the
   header icon group, to the right of Cart. Theme social settings stay the single source. */
(function () {
  function addHeaderSocial() {
    var host = document.querySelector('.section-header-advanced .header-advanced-icons');
    if (!host || host.querySelector('.rh-header-social')) return;
    var links = document.querySelectorAll('.footer-block__list-social .list-social__link');
    if (!links.length) return;
    var row = document.createElement('div');
    row.className = 'rh-header-social';
    row.setAttribute('aria-label', 'The Rub Hub on social media');
    links.forEach(function (src) {
      var net = (src.className.match(/icon-([a-z]+)/) || [])[1];
      if (!net || net === 'smuggler') return;
      var a = document.createElement('a');
      a.href = src.href;
      a.target = '_blank';
      a.rel = 'noopener';
      a.className = 'icon-' + net;
      var label = (src.textContent || net).trim() || net;
      a.setAttribute('aria-label', 'The Rub Hub on ' + label);
      a.title = label;
      row.appendChild(a);
    });
    host.appendChild(row);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addHeaderSocial);
  else addHeaderSocial();
})();
